/**
 * 家を建てる流れ：PHASEアコーディオン（CSS Grid 0fr / 1fr + clip-path）
 */
function initFlowPhaseAccordion() {
  const buttons = document.querySelectorAll('.p-flow-phase__trigger');
  if (!buttons.length) return;

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const accordionMs = 400;

  buttons.forEach((button) => {
    const panelId = button.getAttribute('aria-controls');
    const panel = panelId ? document.getElementById(panelId) : null;
    if (!panel) return;

    let closeTimer = null;

    const getTitleText = () => {
      const title = button.querySelector('.p-flow-phase__title');
      return title ? title.textContent.trim() : '工程';
    };

    const setAria = (isExpanded) => {
      const titleText = getTitleText();
      button.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
      button.setAttribute(
        'aria-label',
        isExpanded ? `${titleText}の工程詳細を閉じる` : `${titleText}の工程詳細を表示`
      );
    };

    const clearCloseTimer = () => {
      if (closeTimer === null) return;
      window.clearTimeout(closeTimer);
      closeTimer = null;
    };

    const openPanel = () => {
      clearCloseTimer();
      panel.hidden = false;
      setAria(true);

      if (prefersReducedMotion) {
        panel.classList.add('is-open');
        return;
      }

      requestAnimationFrame(() => {
        panel.classList.add('is-open');
      });
    };

    const closePanel = () => {
      clearCloseTimer();
      setAria(false);
      panel.classList.remove('is-open');

      if (prefersReducedMotion) {
        panel.hidden = true;
        return;
      }

      const finishClose = () => {
        if (button.getAttribute('aria-expanded') !== 'false') return;
        panel.hidden = true;
      };

      const onEnd = (event) => {
        if (event.propertyName !== 'grid-template-rows') return;
        panel.removeEventListener('transitionend', onEnd);
        clearCloseTimer();
        finishClose();
      };

      panel.addEventListener('transitionend', onEnd);
      closeTimer = window.setTimeout(() => {
        closeTimer = null;
        panel.removeEventListener('transitionend', onEnd);
        finishClose();
      }, accordionMs + 50);
    };

    setAria(false);
    panel.hidden = true;
    panel.classList.remove('is-open');

    button.addEventListener('click', () => {
      const isExpanded = button.getAttribute('aria-expanded') === 'true';
      if (isExpanded) {
        closePanel();
      } else {
        openPanel();
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initFlowPhaseAccordion();
});
